const PROMPT_START_MARKER = "===PROMPT===";
const PROMPT_END_MARKER = "===END PROMPT===";

const removePartialEndMarker = (value: string) => {
  const maximumPrefixLength = Math.min(value.length, PROMPT_END_MARKER.length - 1);

  for (let length = maximumPrefixLength; length > 0; length -= 1) {
    if (value.endsWith(PROMPT_END_MARKER.slice(0, length))) {
      return value.slice(0, -length);
    }
  }

  return value;
};

export const extractPromptReformatStreamPreview = (streamedText: string) => {
  const startIndex = streamedText.indexOf(PROMPT_START_MARKER);
  if (startIndex < 0) return "";

  const promptStart = startIndex + PROMPT_START_MARKER.length;
  const remainingText = streamedText.slice(promptStart).replace(/^\s+/, "");
  const endIndex = remainingText.indexOf(PROMPT_END_MARKER);

  if (endIndex >= 0) {
    return remainingText.slice(0, endIndex).trimEnd();
  }

  return removePartialEndMarker(remainingText);
};
